<app-notification-card iconName="build_circle" title="Working…">
  <p class="mat-font-body-sm mat-text-on-surface-variant mb-0">{{ displayText() }}</p>

  @if (toolNames().length > 0) {
    <p class="mat-font-label-sm mat-text-on-surface-variant mb-0">
      {{ toolNames().join(' · ') }}
    </p>
  }

  <mat-progress-bar mode="indeterminate" />
</app-notification-card>
